import React from 'react';
import { Starfield } from '../components/Starfield';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Stats } from '../components/Stats';
import { Missions } from '../components/Missions';
import { Technology } from '../components/Technology';
import { Fleet } from '../components/Fleet';
import { Team } from '../components/Team';
import { CtaBand } from '../components/CtaBand';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="relative w-full min-h-screen bg-[#03040a] text-white overflow-x-hidden selection:bg-cyan-500/30 selection:text-cyan-100" dir="rtl" data-id="element-217">
      <Starfield data-id="element-218" />
      <Navbar data-id="element-219" />
      <main data-id="element-220">
        <Hero data-id="element-221" />
        <Stats data-id="element-222" />
        <Missions data-id="element-223" />
        <Technology data-id="element-224" />
        <Fleet data-id="element-225" />
        <Team data-id="element-226" />
        <CtaBand data-id="element-227" />
        <Contact data-id="element-228" />
      </main>
      <Footer data-id="element-229" />
    </div>;
}